export default __webpack_public_path__ + "static/award_5-2e6a096f79f43b9306d23d4a7cfed7f5.svg";